import React from "react"
import clsx from "clsx"
import OtaBuilderErrors from "../OtaBuilderErrors"

class OtaBuilderGeneral extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="general">
        { this.renderErrors() }
        { this.renderGeneralForm() }
      </div>
    )
  }

  renderGeneralForm() {

    return (
      <div className="row form-group">
        <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <label>{I18n.t('name')}</label>
          <input 
            id="name"
            type="text" 
            name="name" 
            className= {this.renderFieldClasses('name')} 
            value={this.props.ota.name || ''} 
            onChange={this.props.onChange.bind(this, 'name')}
            />
            {this.renderFieldErrors('name')}
        </div>
      </div>
    )
  }

  renderErrors() {
    if(this.props.errors){
      var errors = OtaBuilderErrors.general(this.props.errors)
      if (errors && errors.length) {
        var idx = 0
        var errors = errors.map((error) => {
          idx = idx + 1
          return <li key={error + idx}>{error}</li>
        })
        return (
          <div className="alert alert-danger">
            <ul>{errors}</ul>
          </div>
        )
      }
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0

      var errors = this.props.errors[field].map( (error) => {
        idx = idx + 1
        return <li key={idx}><b>{field}</b> {error}</li>
      })

      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field) {
    var classname = 'form-control'
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors'
    }
    return classname
  }

  renderFieldClasses(field) {
    var classname = 'form-control'
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors'
    }
    return classname
  }

}

export default OtaBuilderGeneral
